import {Chart, registerables} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import {useEffect, useRef} from "react";

const LineTrendingChart = (props) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    useEffect(() => {
        if (chartRef.current && props.labels && props.line_data) {
            let dsets = [];
            for (let i = 0; i < props.lines; i++) {
                dsets.push({
                    type: "line",
                    label: props?.line_labels[i],
                    data: props?.line_data[i],
                    backgroundColor: [props?.line_color[i]],
                    hoverBackgroundColor: [`${props?.line_color[i]}78`],
                    borderColor: [props?.line_color[i]],
                    borderWidth: 3,
                    pointRadius: 5,
                    pointBorderColor: "#ffffff",
                    pointBorderWidth: 1,
                    pointHoverRadius: 9,
                    pointHoverBackgroundColor: props?.line_color[i],
                    pointBackgroundColor: props?.line_color[i],
                    pointHoverBorderWidth: 2,
                    pointHoverBorderColor: "#ffffff",
                    tension: 0.4,
                    fill: false,
                    yAxisID: "a",
                    order: 1
                })
            }

            // Destroy existing chart if it exists
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }

            // Create new chart
            chartInstance.current = new Chart(chartRef.current, {
                options: {
                    responsive: true,
                    maintainAspectRatio: props?.forceAspect !== undefined ? props.forceAspect : false,
                    resizeDelay: 0,
                    plugins: {
                        legend: {
                            display: true
                        },
                    },
                    scales: {
                        x: {
                            title: {
                                display: props?.x_axis,
                                text: props?.x_axis_title
                            },
                            grid: {
                                display: false
                            },
                        },
                        a: {
                            id: "a",
                            position: "left",
                            title: {
                                display: props?.line_axis,
                                text: props?.line_axis_title,
                                color: props?.line_color[0],
                                font: {
                                    size: 14,
                                    weight: "600"
                                }
                            },
                            grid: {
                                display: false
                            },
                            suggestedMax: 10,
                            suggestedMin: 0,
                            ticks: {
                                callback: function (value) {
                                    return value.toLocaleString()
                                }
                            }
                        }
                    }
                },
                data: {
                    labels: props.labels,
                    datasets: dsets
                }
            });
        }

        // Cleanup function
        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, [props.labels, props.line_data]);

    return (<canvas ref={chartRef} className={"chart-canvas p-1"}
                   style={props?.style ? props.style : {width: "100%", height: "100%", display: "block"}}>
            </canvas>);
};

export default LineTrendingChart;